import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styles from "./EmailTemplate.module.scss";
import classNames from "classnames/bind";
import { useAppDispatch } from "~/redux/hooks";
import FormInput from "~/components/common/form/formInput/FormInput";
import FormInpuEditor from "~/components/common/form/formInpuEditor/FormInpuEditor";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import OutlinedButton from "~/components/common/outlined-button/OutlinedButton";
import { BasicEstimateTemplateFormData } from "~/utils/interface/estimateSetting";
import { handleCreateIntroductionTemplate } from "~/thunks/estimate-setting/estimateSettingThunk";
import { estimateSettingActions } from "~/thunks/estimate-setting/estimateSettingSlice";
import { notify } from "~/utils/helper";

dayjs.extend(relativeTime);
const cx = classNames.bind(styles);

interface EmailTemplateProps {
    templateName?: string;
    templateType?: string;
    location?: string;
    onCancel?: () => void;
}

const EmailTemplate = (props: EmailTemplateProps) => {
    const { templateName: nameFromParent, templateType, onCancel } = props;
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState<BasicEstimateTemplateFormData>({
        templateName: "",
        templateDescription: "",
    });

    useEffect(() => {
        if (nameFromParent != null && nameFromParent !== "") {
            setFormData((prev) => ({ ...prev, templateName: nameFromParent }));
        }
    }, [nameFromParent]);

    const handleUpdateFormData = (update: Partial<BasicEstimateTemplateFormData>) => {
        const data: BasicEstimateTemplateFormData = { ...formData, ...update };
        setFormData({
            templateName: data.templateName ?? "",
            templateDescription: data.templateDescription ?? "",
        });
    };

    const handleAddEmail = () => {
        setLoading(true);
        dispatch(
            handleCreateIntroductionTemplate({
                templateName: formData.templateName ?? "",
                description: formData.templateDescription ?? "",
                type: templateType ?? "",
                content: formData.templateDescription ?? "",
            })
        )
            .unwrap()
            .then(() => {
                dispatch(estimateSettingActions.changeNeedRefreshDataEstimateTemplates(true));
                onCancel?.();
                notify("success", "Create email template successfully");
            })
            .catch((error: any) => {
                notify("error", error?.response?.data?.message || "Create email template failed");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className={cx("email-template-container")}>
            <div className={cx("template-name-block")}>
                <FormInput
                    name="Template Name"
                    text="Template Name"
                    isViewMode={false}
                    placeholder="Template Name"
                    inputkey="templateName"
                    value={formData.templateName ?? ""}
                    height="56px"
                    onChange={(e) => handleUpdateFormData({ templateName: e.target.value })}
                />
            </div>

            <div className={cx("template-info")}>
                <h3 className={cx("template-info-title")}>Email</h3>
                <div className={cx("button-container")}>
                    <OutlinedButton
                        title="Cancel"
                        onClick={() => onCancel?.()}
                        className={cx("cancel-button")}
                    />

                    <PrimaryButton
                        title="Add Email"
                        onClick={handleAddEmail}
                        className={cx("add-email-button")}
                        disabled={loading}
                    />
                </div>
            </div>

            <div className={cx("template-description-block")}>
                <FormInpuEditor
                    name={"templateDescription"}
                    text={""}
                    placeholder={""}
                    inputkey={"templateDescription"}
                    value={formData?.templateDescription}
                    isViewMode={false}
                    errorMessage={""}
                    height="100%"
                    onChange={(value) => {
                        handleUpdateFormData({ templateDescription: value });
                    }}
                />
            </div>
        </div>
    );
};

export default EmailTemplate;